import type { SVGProps } from "react";
export interface BracketCurlyEllipsisVrIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BracketCurlyEllipsisVrIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BracketCurlyEllipsisVrIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.375 18v-3c0-.355-.1-.702-.288-1L2 13.874l-.9-1.2c-.3-.4-.3-.95 0-1.35l.9-1.2.087-.124a1.9 1.9 0 0 0 .288-1.001V6A4.125 4.125 0 0 1 6.5 1.875h1a1.126 1.126 0 0 1 0 2.25h-1c-1.035 0-1.875.84-1.875 1.875v3c0 .78-.222 1.543-.636 2.2l-.189.276-.394.524.394.524.19.276c.413.656.635 1.42.635 2.2v3c0 1.035.84 1.875 1.875 1.875h1a1.126 1.126 0 0 1 0 2.25h-1A4.125 4.125 0 0 1 2.375 18m17 0v-3c0-.893.289-1.762.824-2.476l.393-.524-.393-.524A4.13 4.13 0 0 1 19.375 9V6c0-1.036-.84-1.875-1.875-1.875h-1a1.125 1.125 0 0 1 0-2.25h1A4.125 4.125 0 0 1 21.625 6v3c0 .406.131.8.375 1.125l.9 1.2c.3.4.3.95 0 1.35l-.9 1.2c-.244.325-.375.72-.375 1.125v3a4.125 4.125 0 0 1-4.125 4.125h-1a1.125 1.125 0 0 1 0-2.25h1c1.035 0 1.875-.84 1.875-1.875M11.5 16.129a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm1 .741a.6.6 0 0 0 .112-.245l.013-.125-.013-.127a.6.6 0 0 0-.111-.244zm-1-5.241a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm1 .741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126a.6.6 0 0 0-.111-.244zm-.334-6.486a1.625 1.625 0 1 1-1.782 1.782l-.009-.166.009-.166a1.625 1.625 0 0 1 1.615-1.459zM11.63 8a.62.62 0 0 0 .743 0zM12 6.875a.62.62 0 0 0-.37.125H12zM12 7h.373a.6.6 0 0 0-.246-.113L12 6.875zm1.627 9.5a1.625 1.625 0 0 1-3.242.167l-.009-.168.009-.165A1.625 1.625 0 0 1 12 14.875l.167.009c.82.083 1.46.774 1.46 1.616m0-4.5a1.625 1.625 0 0 1-3.242.167l-.009-.168.009-.165A1.625 1.625 0 0 1 12 10.375l.167.009c.82.083 1.46.774 1.46 1.615Z"
      />
    </svg>
  );
}
